// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => (chunkId + "." + {"account":"62d64996","administration":"3d2dab68"}[chunkId] + ".chunk.js");